<template>
    <Dialog :visible="visible" :modal="true" @hide="onClose" :closable="false" class="custom-dialog">
        <template #header>
        <div class="flex align-items-center justify-content-between border-bottom-1 border-400 w-full">
		    <h2 class="text-xl " style="color: #2C3E50;">{{ headerTitle }}</h2>
            <Button
                @click="handleClose"
                type="button"
                :icon="modalIcon"
                class="p-button-rounded p-button-outlined"
                style="color: red;"
            />
        </div>
	    </template>
        <div v-if="modo === 'crear' || modo === 'ver' || form.FechaRespuesta" class="p-fluid px-7 flex gap-3 flex-column">
            <div class="p-field">
                <label class="font-bold">Departamental</label><span style="color: red;"> *</span>
                <Dropdown
                    :class="{ 'sin-flecha': modo !== 'crear' }"
                    placeholder="Seleccione departamental"
                    v-model="form.DepartamentalID" 
                    :options="departamentales" 
                    optionLabel="Nombre"
                    optionValue="DepartamentalID" 
                    :disabled="soloLectura"
                    @blur="touched.DepartamentalID = true" 
                />
                <small v-if="isFieldInvalid('DepartamentalID')" style="color: red">Campo obligatorio</small>
            </div>

            <div class="p-field">
                <label class="font-bold">Numero de Legajo</label><span style="color: red;"> *</span>
                <InputText 
                    placeholder="Ingrese el número de legajo con el formato MPF-SJ-XXXXX-2025 o OJU-SJ-XXXXX-AAAA"
                    v-model="form.NumeroLegajo" 
                    :class="{ 'p-invalid': touched.NumeroLegajo && (isFieldInvalid('NumeroLegajo') || !esLegajoValido) }"
                    :disabled="soloLectura"
                    @blur="touched.NumeroLegajo = true"
                    @input="formatearLegajo" 
                />
                <small v-if="isFieldInvalid('NumeroLegajo')" style="color: red">Campo obligatorio</small>
                <small v-else-if="touched.NumeroLegajo && !esLegajoValido" style="color: red">Formato inválido. Ej: MPF-SJ-12345-2025</small>
            </div>

            <div class="p-field">
                <label class="font-bold">Nombre</label><span style="color: red;"> *</span>
                <InputText 
                    placeholder="Ingrese el Nombre"
                    v-model="form.NombreVinculado"
                    :class="{ 'p-invalid': touched.NombreVinculado && isFieldInvalid('NombreVinculado')}"
                    @blur="touched.NombreVinculado = true" 
                    :disabled="soloLectura" 
                />
                <small v-if="isFieldInvalid('NombreVinculado')" style="color: red">Campo obligatorio</small>
            </div>

            <div class="p-field">
                <label class="font-bold">Asunto</label>
                <InputText 
                    placeholder="Ingrese el Asunto"
                    v-model="form.Asunto" 
                    :disabled="soloLectura" 
                />
            </div>

            <div class="p-field">
                <label class="font-bold">Descripción</label>
                <Textarea 
                    placeholder="Ingrese Descripción"
                    v-model="form.Descripcion" 
                    :disabled="soloLectura" 
                    autoResize 
                />
            </div>

            <div class="p-field">
                <label class="font-bold">{{!soloLectura ? "Adjuntar Archivo/s" : "Archivos Adjuntos"}}</label><span style="color: red;"> *</span>
                <FileUpload
                    v-if="!soloLectura"
                    :isOnlyNotificationFile="true"
                    :multiple="false"
                    :customUpload="true"
                    chooseLabel="Examine archivos"
                    :showCancelButton="true"
                    :buttonsDelete="true"
                    accept=".pdf,.jpg,.png"
                    @uploader="handleUpload"
                    @parentRemoveFiles="handleRemoveFiles"
                />
                <div v-else class="mt-2 border-2 border-300 py-4">
                    <div v-if="form.archivos && form.archivos.length">
                        <div class="mb-2">
                            <i class="pi pi-file-pdf" style="font-size: 1rem;"></i>
                            <a
                                :href="form.archivos[0].url"
                                target="_blank"
                                class="text-primary cursor-pointer underline ml-2"
                            >
                                {{ form.archivos[0].nombre }}
                            </a>
                        </div>
                    </div>
                    <p v-else style="color: gray;">No hay archivo disponible.</p>
                </div>
            </div>

            <div class="p-field" v-if="soloLectura && isNotificante">
                <label class="font-bold">Estado</label>
                <Dropdown
                    :disabled="form.Estado === 'Finalizado'"
                    placeholder="Seleccione Estado"
                    v-model="form.Estado" 
                    :options="estadosNotificaciones()"
                    @input="touched.Estado = true" 
                />
            </div>
            <div class="flex w-full justify-content-end gap-2" v-if="(soloLectura && isNotificante && !form.FechaRespuesta) || (isNotificante && form.FechaRespuesta)">
                <Button class="w-2 p-button-outlined" label="Cancelar" @click="onClose" :disabled="!touched.Estado"/>
                <Button class="w-2" label="Confirmar" @click="openModal" :disabled="!touched.Estado"/>
            </div>

            <div class="flex w-full justify-content-center" v-if="!soloLectura">
                <Button class="w-3" label="Enviar Notificación" icon="pi pi-send" @click="crearNotificacion" :disabled="!isFormValid"/>
            </div>
            <div class="flex w-full justify-content-center" v-if="!isNotificante && !form.FechaRespuesta">
                <Button class="w-3" label="Responder Notificación" icon="pi pi-send" @click="handleResponse"/>
            </div>            
        </div>
        
        <div class="flex align-items-center justify-content-between border-bottom-1 border-400 w-full mb-4" v-if="form.FechaRespuesta">
            <h2 class="text-xl " style="color: #2C3E50;">Respuesta</h2>
        </div>

        <div v-if="modo!== 'crear' && (modo === 'respuesta' || form.FechaRespuesta)" class="p-fluid px-7 flex gap-3 flex-column">
            <div class="p-field">
                <label class="font-bold">Contacto de la departamental a cargo</label><span style="color: red;"> *</span>
                <InputText
                    v-model="answerForm.Contacto"
                    placeholder="Ingrese un contacto válido"
                    :disabled="soloLectura"
                />
            </div>
            <div class="p-field">
                <label class="font-bold">Descripción</label>
                <Textarea
                    v-model="answerForm.Descripcion"
                    placeholder="Ingrese descripción de la respuesta"
                    autoResize
                    :disabled="soloLectura"
                />
            </div>
            <div class="p-field">
                <label class="font-bold">{{!soloLectura ? "Adjuntar Archivo/s" : "Archivos Adjuntos"}}</label><span style="color: red;"> *</span>
                <FileUpload
                    v-if="!soloLectura || !form.FechaRespuesta"
                    :isOnlyNotificationFile="true"
                    :multiple="false"
                    :customUpload="true"
                    chooseLabel="Examinar archivo"
                    :showCancelButton="true"
                    :buttonsDelete="true"
                    accept=".pdf,.jpg,.png"
                    @uploader="handleUpload"
                    @parentRemoveFiles="handleRemoveFiles"
                />
                <div v-else class="mt-2 border-2 border-300 py-4">
                    <div v-if="form.archivos && form.archivos.length">
                        <div class="mb-2">
                            <i class="pi pi-file-pdf" style="font-size: 1rem;"></i>
                            <a
                                :href="form.archivos[1].url"
                                target="_blank"
                                class="text-primary cursor-pointer underline ml-2"
                            >
                                {{ form.archivos[1].nombre }}
                            </a>
                        </div>
                    </div>
                    <p v-else style="color: gray;">No hay archivo disponible.</p>
                </div>
            </div>
            <div class="flex w-full justify-content-center" v-if="!form.FechaRespuesta">
                <Button
                    label="Enviar Respuesta"
                    icon="pi pi-send"
                    class="w-3"
                    @click="sendResponse"
                    :disabled="!isRespuestaValida"
                />
            </div>
        </div>
        <template v-if="isLoading || (modo === 'ver' && notificacion && notificacion.isLoading)">
            <div class="overlay-loading">
                <i class="pi pi-spin pi-spinner" style="font-size: 3rem; color: white;"></i>
            </div>
        </template>
        <ModalTemplate
            title="Confirmación de Eliminación"
            type="confirmativo"
            message="¿Está seguro de que desea eliminar este elemento?"
            :showIcon="true"
            severity="danger"
            @confirm="deleteConfirmed"
            @cancel="cancelDelete"
            ref="ModalRefDelete"
        />
        <ModalTemplate
            title="Confirmación de cambio de estado"
            type="confirmativo"
            message="¿Está seguro de que deseas cambiar el estado?"
            :showIcon="true"
            severity="danger"
            @confirm="handleEstado"
            @cancel="closeModal"
            ref="ModalRefEstado"
        />
    </Dialog>
</template>

<script>
import FileUpload from "../custom-fileupload/FileUpload.vue";
import ModalTemplate from '../../components/ModalTemplate.vue'
import { defineComponent, onMounted, reactive, ref, computed, watch} from "vue";
import { useStoreCompat } from "@/composables/useStoreCompat";
import { useRest } from "@/composables/useRest";
import { useToast } from "@/composables/useToast";

export default defineComponent({
    name: "ModalNotificacion",
    components:{
        FileUpload,
        ModalTemplate
    },
    props: {
        visible: Boolean,
        modo: {
            type: String,
            default: "crear",
        },
        notificacion: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props, { emit }) {
        const store = useStoreCompat()
        const rest = useRest()
        const toast = useToast()
        
        const form = ref({})
        const archivos = ref([])
        const answerForm = reactive({
            Contacto: '',
            Descripcion: '',
            UsuarioID: '',
            NotificacionID: ''
        })
        const touched = reactive({
            DepartamentalID: false,
            NumeroLegajo: false,
            NombreVinculado: false,
            archivos: false,
            Estado: false
        })

        const estadosDisponibles = ['Enviado', 'Respondido', 'Finalizado']

        const estadosNotificaciones = () => {
            if (form.value?.Estado === 'Respondido') {
                return ['Finalizado']
            }
            return estadosDisponibles
        }

        const isLoading = ref(false)
        const ModalRefDelete = ref(null)
        const ModalRefEstado = ref(null)

        const departamentales = computed(() => store.state.siis.departamentales)
        const user = computed(() => store.state.user.userdata)
        const soloLectura = computed(() => props.modo === 'ver')
        const isNotificante = computed(() => user.value?.tipoUsuario === 'Notificante')
        const isRespuestaValida = computed(() =>
            answerForm.Contacto && archivos.value.length > 0
        )

        const isFormValid = computed(() => {
            return (
                form.value.DepartamentalID &&
                form.value.NumeroLegajo &&
                esLegajoValido.value &&
                form.value.NombreVinculado &&
                archivos.value.length > 0
            )
        })

        const esLegajoValido = computed(() => /^[A-Z]{3}-[A-Z]{2}-\d{5}-\d{4}$/.test(form.value.NumeroLegajo))
        
        const headerTitle = computed(() => {
            if (props.modo === 'respuesta') return 'Responder Notificación'
            return soloLectura.value ? 'Ver Notificación' : 'Nueva Notificación'
        })

        const modalIcon = computed(() => {
            if (props.modo === 'respuesta') return 'pi pi-trash'
            return props.modo === 'crear' ? 'pi pi-trash' : 'pi pi-times'
        })

        onMounted(() => {
            store.dispatch("siis/setDepartamentales")
        })

        const resetForm = () => {
            form.value = {}
            archivos.value = []
            Object.assign(touched, {
                DepartamentalID: false,
                NumeroLegajo: false,
                NombreVinculado: false,
                archivos: false,
                Estado: false
            })
            Object.assign(answerForm, {
                Contacto: '',
                Descripcion: '',
                UsuarioID: '',
                NotificacionID: ''
            })
        }

        watch(
            () => props.notificacion,
            (val) => {
                if (props.modo === 'ver' && val && !val.isLoading) {
                    Object.assign(form.value, val)
                    answerForm.NotificacionID = val.NotificacionID
                    answerForm.UsuarioID = user.value?.userId
                    if(val.FechaRespuesta){
                        answerForm.Contacto = val.RespuestaContacto
                        answerForm.Descripcion = val.RespuestaDescripcion
                    }
                } else if (props.modo === 'crear') {
                    resetForm()
                }
            },
            { immediate: true }
        )

        watch(
            () => props.modo,
            (nuevoModo) => {
                if (nuevoModo === 'crear') {
                    resetForm()
                }
            }
        )

        const isFieldInvalid = (field) => {
            return touched[field] && !form.value[field];
        }

        const onClose = () => {
            emit('close')
            resetForm() 
        }

        const handleUpload = ({ files }) => {
            if (files.length > 0) {
                archivos.value = files;
                touched.archivos = true;
            }
        }

        const handleClose = () => {
            if(props.modo === 'crear' || props.modo === 'respuesta'){
                ModalRefDelete.value?.open(); 
            }else{
                onClose();
            }
        }

        const deleteConfirmed = () => {
            ModalRefDelete.value?.close();
            onClose();
        }

        const cancelDelete = () => {
            ModalRefDelete.value?.close(); 
        }

        const handleRemoveFiles = () =>  {
            archivos.value = [];
        }

        const openModal = () => {
            ModalRefEstado.value?.open()
        }
        const closeModal = () => {
            ModalRefEstado.value?.close()
        }

        const formatearLegajo = (event) => {
            let value = event.toUpperCase().replace(/[^A-Z0-9]/g, '');
            let formatted = '';
            if (value.length > 0) formatted += value.substring(0, 3);
            if (value.length > 3) formatted += '-' + value.substring(3, 5);
            if (value.length > 5) formatted += '-' + value.substring(5, 10);
            if (value.length > 10) formatted += '-' + value.substring(10, 14);
            form.value.NumeroLegajo = formatted;
        }

        const crearNotificacion = async () => {
            isLoading.value = true;
            try {
                const postOptions = {
                    url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/notificaciones`,
                    formData: form.value
                };
                const { data } = await rest.post(postOptions);
                const formDataFiles = new FormData();
                formDataFiles.append('NotificacionID', data.data.NotificacionID);
                formDataFiles.append('NombreArchivo', archivos.value[0].name);
                formDataFiles.append('userfile', archivos.value[0]);

                const postOptionsFiles = {
                    url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/notificacion`,
                    formData: formDataFiles
                };
                await rest.post(postOptionsFiles);

                toast.success("Notificación creada");

                emit("getNotifications");
                onClose();
            } catch (error) {
                toast.error("Error al crear");
            } finally {
                isLoading.value = false;
            }
        }

        const sendResponse = async () => {
            isLoading.value = true;
            try {   
                const postOptions = {
                    url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/respuesta-notificacion`,
                    formData: answerForm
                };
                const { data } = await rest.post(postOptions);
                const formDataFiles = new FormData();
                formDataFiles.append('RespuestaNotificacionID', data.data.RespuestaNotificacionID);
                formDataFiles.append('NombreArchivo', archivos.value[0].name);
                formDataFiles.append('userfile', archivos.value[0]);

                const postOptionsFiles = {
                    url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/files/notificacion`,
                    formData: formDataFiles
                };
                await rest.post(postOptionsFiles);

                toast.success("Respuesta enviada");

                emit("getNotifications");
                onClose();
            } catch (error) {
                toast.error("Error al Responder");
            } finally {
                isLoading.value = false;
            }
        }

        const handleEstado = async () => {
            isLoading.value = true;
            try {
                const putOptions = {
                    url: `${process.env.VUE_APP_BACKEND_ENVIRONMENT}/notificaciones/${form.value.NotificacionID}`,
                    formData: { ...form.value }
                };
                await rest.put(putOptions);
                toast.success("Estado actualizado correctamente.");
                
                emit("getNotifications");
                onClose();
            } catch (error) {
                toast.error("No se pudo actualizar el estado. Intente nuevamente.");
            } finally {
                isLoading.value = false;
            }
        }

        
        
        const handleResponse = () => {
            emit('updateModo', 'respuesta')
        }

        return {
            form,
            archivos,
            touched,
            answerForm,
            estadosNotificaciones,
            isLoading,
            ModalRefDelete,
            ModalRefEstado,
            departamentales,
            user,
            soloLectura,
            isNotificante,
            isFormValid,
            esLegajoValido,
            headerTitle,
            modalIcon,
            isRespuestaValida,
            isFieldInvalid,
            onClose,
            handleClose,
            deleteConfirmed,
            cancelDelete,
            handleUpload,
            handleRemoveFiles,
            formatearLegajo,
            crearNotificacion,
            sendResponse,
            handleEstado,
            handleResponse,
            openModal,
            closeModal
        }
    }
});
</script>

<style scoped>
    .overlay-loading {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 9999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    >>> .custom-dialog.p-dialog {
        width: 1300px;
        height: 80%;
    }
    :deep(.p-dialog-content) {
        height: 100% !important;
    }
    
    @media (max-width: 768px) {
        >>> .custom-dialog.p-dialog {
            width: 95vw;
            margin: 0 auto;
        }
    }
    :deep(.sin-flecha .p-dropdown-trigger) {
        display: none;
    }
</style>